export const TONContracts = {
  'USDT': {
    MasterAddress: 'EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs',
    decimal: 6
  },
  'NOT': {
    MasterAddress: 'EQAvlWFDxGF2lXm67y4yzC17wYKD9A0guwPkMs1gOsM__NOT',
    decimal: 9
  }
};
